import SideNav, { NavIcon, NavItem, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import { detect } from "detect-browser";
// import firebase from "firebase";
import "font-awesome/css/font-awesome.min.css";
import React, { Component } from "react";
import { Image } from "react-bootstrap";
import ClickOutside from "react-click-outside";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import uuid from "react-uuid";
import bottle from "../../../assets/images/bottle.svg";
import dollar from "../../../assets/images/dollar.svg";
import find from "../../../assets/images/find-sidebar.svg";
import heart from "../../../assets/images/heart.svg";
import home from "../../../assets/images/home-sidebar.svg";
import imgTele from "../../../assets/images/imgTele.svg";
import idcard from "../../../assets/images/menu-idcard.svg";
import trolley from "../../../assets/images/trolley.svg";
import {
  logFirebaseEvent,
  userLogsFirebaseEvent,
} from "../../../shared/utility";
import * as homeActions from "../../../store/actions/";
import * as resetActions from "../../../store/actions/";
import classes from "./Sidebar.module.css";
const browser = detect();

interface IStateFromProps {
  appConfig: {
    modules: string[];
    theme: string;
  };
  error: boolean;
  loading: boolean;
  parseAccessTokenLoading: boolean;
  accessTokenParsed: boolean;
  t: any;
  i18n: any;
}

interface IDispatchFromProps {
  onParsingAccessToken: () => void;
  onResetSearchParam: () => void;
  onFetchAppConfig: () => void;
  onSetBalanceBillViewState: (balanceBillView) => void;
  onSetMyBillViewState: (myBillView) => void;
}

type Props = IStateFromProps & IDispatchFromProps & RouteComponentProps;
class Sidebar extends Component<Props> {
  state = {
    expanded: false,
    selected: "home",
    modules:
      localStorage.getItem("modulesConfig") &&
      localStorage.getItem("modulesConfig") !== ""
        ? localStorage.getItem("modulesConfig")?.split(",")
        : [],
  };
  componentDidMount() {
    console.log("i18n-----------", this.props.i18n.language);
    if (browser) {
      logFirebaseEvent(browser.name);
      logFirebaseEvent(browser.os!);
    }
    this.props.onResetSearchParam();
    this.props.onParsingAccessToken();
    this.props.onSetBalanceBillViewState("notGetStarted");
    this.props.onSetMyBillViewState("");
  }

  componentDidUpdate(prevProps) {
    console.log("modules", localStorage.getItem("modulesConfig")?.split(","));
    if (this.props.accessTokenParsed !== prevProps.accessTokenParsed) {
      this.props.onFetchAppConfig();
      this.setState({
        modules:
          localStorage.getItem("modulesConfig") &&
          localStorage.getItem("modulesConfig") !== ""
            ? localStorage.getItem("modulesConfig")?.split(",")
            : [],
      });
    }
    const { appConfig } = { ...this.props };
    if (
      JSON.stringify(prevProps.appConfig) !== JSON.stringify(appConfig) &&
      appConfig
    ) {
      // commented the line because of modules from token
      // const { modules, theme } = appConfig;
      const { theme } = appConfig;
      // update the body id to set the theme
      if (document.body.id !== theme) {
        document.body.id = theme;
      }
      // commented the line because of modules from token
      // update state with the latest modules for features display
      // if (Array.isArray(modules) && modules.length > 0) {
      //   this.setState({ modules });
      // }
      userLogsFirebaseEvent();
    }
  }
  onSelectHandler = (selected: string) => {
    console.log("selected/" + selected);
    const selectedState = this.getCurrentSelectedState();
    this.toggleHandler(false);
    if (selectedState === selected) {
      this.setState({ expanded: false });
      return false;
    }
    if (selected !== "prescriptions") {
      this.props.history.push("/" + selected);
      this.props.onResetSearchParam();
      this.props.onSetBalanceBillViewState("notGetStarted");
      this.props.onSetMyBillViewState("");
    }
  };
  toggleHandler = (expanded) => {
    if (expanded) {
      this.openSidebar();
    } else {
      this.hideSidebar();
    }
  };
  openSidebar = () => {
    document.body.classList.remove("sidebarCollapsed");
    document.body.classList.add("sidebarExpanded");
    this.setState({ expanded: true });
  };
  hideSidebar = () => {
    document.body.classList.add("sidebarCollapsed");
    document.body.classList.remove("sidebarExpanded");
    this.setState({ expanded: false });
  };
  getCurrentSelectedState() {
    const { location = { pathname: "" } } = this.props;
    const { pathname } = location;

    return pathname === "/" ? "home" : pathname.substring(1);
  }

  render() {
    const { t } = this.props;

    var className = this.state.expanded ? "sidebarExp" : "sidebar";
    const selectedState = this.getCurrentSelectedState();

    let modules: any;
    if (this.state.modules) {
      modules = this.state.modules.map((module) => {
        if (module === "Find Provider") {
          return (
            <NavItem
              eventKey="find-provider"
              className={[classes.sidebarIcon, classes.iconSizeL].join(" ")}
              key={uuid()}
            >
              <NavIcon>
                <Image
                  src={find}
                  alt="Find Provider"
                  className={classes.find}
                />
              </NavIcon>
              <NavText>
                <span className="menuText">{t("homePage.findProvider")}</span>
              </NavText>
            </NavItem>
          );
        } else if (module === "Balance Billing") {
          return (
            <NavItem
              eventKey="balance-billing"
              className={[classes.sidebarIcon, classes.iconSize].join(" ")}
              key={uuid()}
            >
              <NavIcon>
                <Image
                  src={dollar}
                  alt="Balance Billing"
                  className={classes.dollar}
                />
              </NavIcon>
              <NavText>
                <span className="menuText subMenu">
                  {t("homePage.balanceBilling")}{" "}
                </span>
              </NavText>
              <NavItem
                eventKey="balance-billing-newupload"
                className="subMenuItem"
                key={uuid()}
              >
                <NavText>
                  <span className="subMenuText">
                    {t("balanceBills.claims")}
                  </span>
                </NavText>
              </NavItem>
              <NavItem
                eventKey="balance-billing-mybills"
                className="subMenuItem"
                key={uuid()}
              >
                <NavText>
                  <span className="subMenuText">
                    {t("balanceBilling.subTitle")}
                  </span>
                </NavText>
              </NavItem>
            </NavItem>
          );
        } else if (module === "Procedure Shopper") {
          return (
            <NavItem
              eventKey="procedure-shopper"
              className={classes.sidebarIcon}
              key={uuid()}
            >
              <NavIcon>
                <Image
                  src={trolley}
                  alt="Procedure Shopper"
                  className={classes.trolley}
                />
              </NavIcon>
              <NavText>
                <span className="menuText">
                  {t("homePage.procedureShopper")}
                </span>
              </NavText>
            </NavItem>
          );
        } else if (module === "Telemedicine") {
          return (
            <NavItem
              eventKey="telemedicine"
              className={classes.sidebarIcon}
              key={uuid()}
            >
              <NavIcon>
                <Image
                  src={imgTele}
                  alt="telemedicine"
                  className={classes.iconTele}
                />
              </NavIcon>
              <NavText>
                <span className="menuText">{module}</span>
              </NavText>
            </NavItem>
          );
        } else if (module === "My Favorites") {
          return (
            <NavItem
              eventKey="my-favorites"
              className={classes.sidebarIcon}
              key={uuid()}
            >
              <NavIcon>
                <Image src={heart} alt="heart" className={classes.heart} />
              </NavIcon>
              <NavText>
                <span className="menuText">{t("homePage.myFavorite")}</span>
              </NavText>
            </NavItem>
          );
        } else if (module === "Prescriptions") {
          return (
            <NavItem
              eventKey="prescriptions"
              className={classes.sidebarIcon}
              key={uuid()}
            >
              <NavIcon>
                <Image
                  src={bottle}
                  alt="Prescriptions"
                  className={classes.bottle}
                />
              </NavIcon>
              <NavText>
                <span className="menuText">{module}</span>
              </NavText>
            </NavItem>
          );
        }
        // else if (module === "ID Card") {
        //   return (
        //     <NavItem eventKey="idcard" className={classes.iconSizeL}>
        //       <NavIcon>
        //         <Image src={idcard} alt="ID Card" className={classes.idcard} />
        //       </NavIcon>
        //       <NavText className="{classes.navText2}">
        //         <span className="menuText">ID Card</span>
        //       </NavText>
        //     </NavItem>
        //   );
        // }
        return null;
      });
      // return null;
    }

    return (
      <>
        <div
          style={{
            background: "black",
            width: "100vw",
            height: "100vh",
            display: this.state.expanded ? "block" : "none",
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 100,
            opacity: 0.4,
          }}
          onClick={() => {
            this.hideSidebar();
          }}
        />
        <SideNav
          className={className}
          expanded={this.state.expanded}
          onToggle={(expanded: boolean) => {
            this.toggleHandler(expanded);
          }}
          onSelect={this.onSelectHandler}
        >
          <SideNav.Toggle className="toggleNav" />
          <SideNav.Nav selected={selectedState} className={classes.sidebarMob}>
            <NavItem eventKey="home" className={classes.sidebarIcon}>
              <NavIcon>
                <Image src={home} alt="Home" className={classes.home} />
              </NavIcon>
              <NavText className="{classes.navText2}">
                <span className="menuText">{t("menuBar.home")}</span>
              </NavText>
            </NavItem>
            {modules}
            <NavItem eventKey="idcard" className={classes.iconSizeL}>
              <NavIcon>
                <Image src={idcard} alt="ID Card" className={classes.idcard} />
              </NavIcon>
              <NavText className="{classes.navText2}">
                <span className="menuText">{t("idCard.idCardTitle")}</span>
              </NavText>
            </NavItem>
          </SideNav.Nav>
        </SideNav>
      </>
    );
  }
  classes(arg0: { expanded: boolean }) {
    throw new Error("Method not implemented.");
  }
}
const mapStateToProps = (state: any) => ({
  appConfig: state.appConfig.appConfig,
  error: state.appConfig.error,
  loading: state.appConfig.loading,
  parseAccessTokenLoading: state.parseAccessToken.parseAccessTokenLoading,
  accessTokenParsed: state.parseAccessToken.accessTokenParsed,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onParsingAccessToken: () => dispatch(homeActions.parseAccessToken()),
  onResetSearchParam: () => dispatch(resetActions.resetSearchParam()),
  onFetchAppConfig: () =>
    dispatch(homeActions.fetchAppConfig(localStorage.getItem("userId")!, "en")),
  onSetBalanceBillViewState: (balanceBillView) =>
    dispatch(homeActions.setBalanceBillViewState(balanceBillView)),
  onSetMyBillViewState: (myBillView) =>
    dispatch(homeActions.setMyBillViewState(myBillView)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(Sidebar)));
// export default withRouter(Sidebar);
